import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';

import QRFullLogo from '~/assets/icons/sidebar-logo-new.svg?react';
import ContentContainer from '~/components/atoms/content-container/ContentContainer';
import { getLoggedInUser } from '~/store/reducers/account/selector';
import { COLORS } from '~/styles/colors';
import { isMobileResolution } from '~/utils/common';

import PaymentContainer from './components/PaymentContainer';
import Summary from './components/Summary';

export default function PaymentsCheckout() {
  const { t } = useTranslation();
  const { data } = useSelector(getLoggedInUser);

  const navigate = useNavigate();
  const location = useLocation();

  const handleChangePlan = () => {
    navigate(-1);
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: COLORS.white }}>
        <Toolbar variant="dense">
          <Box sx={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'space-between' }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => navigate(-1)}
              sx={{
                mr: 5,
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'inherit',
                },
              }}
            >
              <QRFullLogo />
            </IconButton>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography color={COLORS.black08} fontSize={14} sx={{ pr: 2 }}>
                {data.email || ''}
              </Typography>
              <Avatar src="/broken-image.jpg" sx={{ width: 24, height: 24 }} />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        display="flex"
        flexDirection={isMobileResolution ? 'column' : 'row'}
        flex={1}
        pr={0}
        pb={0}
        mt={isMobileResolution ? 5 : 0}
      >
        <Box display="flex" flexDirection="column" sx={{ flex: 1, mr: 2, pl: 3, pt: 3 }}>
          <ContentContainer
            display="flex"
            justifyContent="space-between"
            resetPadding
            title={' '}
            containerStyles={{ margin: '0 12px 0 0', flex: 1, mb: 3 }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent={isMobileResolution ? 'space-between' : 'flex-start'}
              flex={1}
              m={2}
            >
              <Typography fontSize={24} flex={0.4}>
                {t('checkout:selectPlan')}
              </Typography>
              <Box display="flex" alignItems="center">
                <Typography>
                  {location.state.period} {t('checkout:period')}
                </Typography>
                <IconButton aria-label="delete" onClick={() => handleChangePlan()}>
                  <EditIcon />
                </IconButton>
              </Box>
            </Box>
          </ContentContainer>
          <PaymentContainer />
        </Box>

        <Box display="flex" flexDirection="column" sx={{ flex: 0.5 }}>
          <Summary plan={location.state.period} />
        </Box>
      </Box>
    </>
  );
}
